const brickCreationScript = `
  const unmountStatusScreenBrick = async () => {
    if (window.statusScreenBrickController) {
      try {
        await window.statusScreenBrickController.unmount();
        window.statusScreenBrickController = null;
      } catch (error) {
        console.error('Error during unmount:', error);
      }
    }
  };

  unmountStatusScreenBrick();

  const mp = new MercadoPago(window.cardStatusScreenBricksProps.publicKey, {
    locale: window.cardStatusScreenBricksProps.language,
    trackingDisabled: true
  });
  const bricksBuilder = mp.bricks({theme: window.cardStatusScreenBricksProps.theme});
  const renderStatusScreenBrick = async (bricksBuilder) => {
    const settings = {
      initialization: {
        paymentId: window.cardStatusScreenBricksProps.paymentId, // id do pagamento gerado pelo mercado pago
      },
      callbacks: {
         onReady: () => {
           // callback chamado quando o Brick estiver pronto
         },
         onError: (error) => {
         // callback chamado para todos os casos de erro do Brick
         },
       },
      customization: {
        visual: {
          showExternalReference: window.cardStatusScreenBricksProps.showExternalReference,
          hideStatusDetails: window.cardStatusScreenBricksProps.hideStatusDetails,
          hideTransactionDate: window.cardStatusScreenBricksProps.hideTransactionDate,
          texts: window.cardStatusScreenBricksProps.texts,
          style: {
            customVariables: window.cardStatusScreenBricksProps.customVariables,
          },
        },
        backUrls: {
          'error': window.location,
          'return': window.location
        }
      },
    };
    window.statusScreenBrickController = await bricksBuilder.create('statusScreen', 'statusScreenBrick_container', settings);
  };
  renderStatusScreenBrick(bricksBuilder);
  `;

const paymentInterceptor = `
  (function() {
    if (!window.oldXHROpen) {
      window.oldXHROpen = window.XMLHttpRequest.prototype.open;
    }

    window.XMLHttpRequest.prototype.open = function(method, url, async, user, password) {
      if (url.includes('/bricks/payments')) {
        var data = {
          payment_id: window.cardStatusScreenBricksProps.paymentId,
          status: window.cardStatusScreenBricksProps.status,
          status_detail: 'expired',
          transaction_paid_amount: 100,
          transaction_creation_date: '2022-10-18T13:43:54.598-04:00',
          external_reference: 'Código de referência externa',
          description: 'Mercado Pago Point',
          installments_quantity: 1,
          payment_type_data: {
            expiration_date: '2022-10-23T13:43:54.688-04:00',
            payment_point: '7_eleven',
            url: 'https://www.mercadopago.com.mx/sandbox/payments/1308789998/ticket?caller_id=514522042&payment_method_id=oxxo&payment_id=1308789998&payment_method_reference_id=6003246882&hash=2c26fcd7-224e-439c-8864-4d899eca7938',
          },
          is_wallet: true,
          partially_supported_payment: false,
        };

        this.addEventListener('load', function() {
          Object.defineProperty(this, "responseText", {writable: true});
          this.responseText = JSON.stringify(data);
        });
      } else if (url.includes('/new_theme')) {
        const isActive = window.cardStatusScreenBricksProps.brand === "cyan-light" ? false : true;
        const mockData = { is_active: isActive };

        this.addEventListener('load', function() {
          Object.defineProperty(this, 'responseText', { writable: true });
          this.responseText = JSON.stringify(mockData);
        });
      }

      return window.oldXHROpen.apply(this, arguments);
    };
  })();
`;

const PAYMENTS_ID = {
  approved: '1311168563',
  pending: '1311166941',
  rejected: '1311166947',
};

function getPaymentNameById(id) {
  return Object.keys(PAYMENTS_ID).find((key) => PAYMENTS_ID[key] === id);
}

module.exports = { brickCreationScript, paymentInterceptor, PAYMENTS_ID, getPaymentNameById };
